module.exports = __webpack_public_path__ + "static/media/icomoon.abd915f8.woff";